(() => {
  if (customElements.get('vk-cover-upsell')) return;
  class VinkovaCoverUpsell extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.toggle = this.querySelector('[data-vk-cover-toggle]');
      this.panel = this.querySelector('[data-vk-cover-panel]');
      this.grid = this.querySelector('[data-vk-cover-grid]');
      this.error = this.querySelector('[data-vk-cover-error]');
      this.selection = this.querySelector('[data-vk-cover-selection]');
      this.total = this.querySelector('[data-vk-cover-total]');
      this.apparatusToggle = this.querySelector('[data-vk-apparatus-toggle]');
      this.apparatusPanel = this.querySelector('[data-vk-apparatus-panel]');
      this.apparatusGrid = this.querySelector('[data-vk-apparatus-grid]');
      this.apparatusType = this.querySelector('[data-vk-apparatus-type]');
      this.apparatusVariant = this.querySelector('[data-vk-apparatus-variant]');
      this.apparatusTypes = Array.from(this.apparatusType.options).map(option => ({ value: option.value, text: option.textContent }));
      this.variants = JSON.parse(this.querySelector('[data-vk-cover-variants]').textContent);
      this.covers = JSON.parse(this.querySelector('[data-vk-cover-catalog]').textContent);
      this.apparatus = JSON.parse(this.querySelector('[data-vk-apparatus-catalog]').textContent);
      this.info = this.closest('product-info') || this.closest('.shopify-section');
      this.form = document.getElementById(this.dataset.formId) || this.info?.querySelector('form[action*="/cart/add"]');
      if (!this.form) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.toggle.addEventListener('change', () => this.onToggle(), options);
      this.apparatusToggle.addEventListener('change', () => this.onToggle(), options);
      this.grid.addEventListener('click', event => {
        const button = event.target.closest('[data-cover-id]');
        if (button) this.select(Number(button.dataset.coverId));
      }, options);
      this.apparatusGrid.addEventListener('click', event => {
        const button = event.target.closest('[data-apparatus-id]');
        if (button) this.selectApparatus(Number(button.dataset.apparatusId));
      }, options);
      this.apparatusType.addEventListener('change', () => {
        this.renderApparatus();
        this.apparatusGrid.scrollTop = 0;
      }, options);
      this.apparatusVariant.addEventListener('change', () => {
        this.apparatusVariantId = Number(this.apparatusVariant.value) || null;
        this.renderApparatusDetails();
        this.showError('');
        this.updateTotal();
      }, options);
      this.info?.addEventListener('change', () => this.updateTotal(), options);
      this.form.addEventListener('variant:change', () => this.updateTotal(), options);
      if (!this.closest('.vk-size')) this.form.addEventListener('submit', event => this.onSubmit(event), { ...options, capture: true });
      this.render();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.ready = false;
    }

    money(cents) {
      return new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: 'EUR' }).format(cents / 100);
    }

    discountedPrice(variant) {
      return variant.price - Math.round(variant.price * 0.25);
    }

    selectedApparatus() {
      return this.apparatus.find(item => item.id === this.apparatusId);
    }

    selectedApparatusVariant() {
      return this.selectedApparatus()?.variants.find(item => item.id === this.apparatusVariantId);
    }

    hasOffer() {
      return this.toggle.checked || this.apparatusToggle.checked;
    }

    updateTotal() {
      const variantId = Number(this.form.querySelector('[name="id"]')?.value);
      const variant = this.variants.find(item => item.id === variantId);
      const quantity = Math.max(1, Number(new FormData(this.form).get('quantity') || 1));
      const apparatus = this.apparatusToggle.checked && this.selectedApparatusVariant();
      const extras = (this.toggle.checked && this.selectedId ? 1500 : 0) + (apparatus ? this.discountedPrice(apparatus) : 0);
      this.querySelector('[data-vk-total-row]').hidden = !this.hasOffer();
      const preview = this.toggle.checked && this.apparatusToggle.checked && this.dataset.combinationsReady !== 'true';
      this.querySelector('[data-vk-total-label]').textContent = preview ? this.dataset.previewTotalLabel : this.dataset.totalLabel;
      this.querySelector('[data-vk-combination-note]').hidden = !preview;
      if (variant) this.total.textContent = this.money((variant.price + extras) * quantity);
    }

    imageButton(item, attribute, selected) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'vk-cover__design';
      button.setAttribute(attribute, String(item.id));
      button.setAttribute('aria-label', item.title);
      button.setAttribute('aria-pressed', String(item.id === selected));
      button.title = item.title;
      const img = document.createElement('img');
      img.src = item.image;
      img.alt = '';
      img.width = 120;
      img.height = 100;
      img.loading = 'lazy';
      button.append(img);
      return button;
    }

    render() {
      this.grid.replaceChildren(...this.covers.map(cover => this.imageButton(cover, 'data-cover-id', this.selectedId)));
      this.querySelector('[data-vk-cover-option]').hidden = !this.covers.length;
      this.panel.querySelector('.vk-cover__more').hidden = this.covers.length <= 8;
      if (!this.covers.length) this.toggle.checked = false;
      this.querySelector('[data-vk-apparatus-option]').hidden = !this.apparatus.length;
      if (!this.apparatus.length) this.apparatusToggle.checked = false;
      const currentType = this.apparatusType.value;
      this.apparatusType.replaceChildren();
      this.apparatusTypes.forEach(type => {
        if (type.value && !this.apparatus.some(item => item.type === type.value)) return;
        const option = document.createElement('option');
        option.value = type.value;
        option.textContent = type.text;
        this.apparatusType.append(option);
      });
      this.apparatusType.value = this.apparatus.some(item => item.type === currentType) ? currentType : '';
      this.renderApparatus();
      this.hidden = !this.covers.length && !this.apparatus.length;
      this.updatePanels();
      this.updateTotal();
    }

    renderApparatus() {
      const products = this.apparatus.filter(item => !this.apparatusType.value || item.type === this.apparatusType.value);
      this.apparatusGrid.replaceChildren(...products.map(item => this.imageButton(item, 'data-apparatus-id', this.apparatusId)));
      this.querySelector('[data-vk-apparatus-more]').hidden = products.length <= 8;
      this.renderApparatusDetails();
    }

    select(id) {
      this.selectedId = id;
      const cover = this.covers.find(item => item.id === id);
      this.grid.querySelectorAll('[data-cover-id]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.coverId) === id)));
      this.selection.textContent = cover ? this.dataset.selected.replace('[name]', cover.title) : '';
      this.showError('');
      this.updateTotal();
    }

    selectApparatus(id) {
      if (this.apparatusId !== id) {
        this.apparatusId = id;
        const product = this.selectedApparatus();
        this.apparatusVariantId = product?.variants.length === 1 ? product.variants[0].id : null;
      }
      this.apparatusGrid.querySelectorAll('[data-apparatus-id]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.apparatusId) === id)));
      this.renderApparatusDetails();
      this.showError('');
      this.updateTotal();
    }

    renderApparatusDetails() {
      const product = this.selectedApparatus();
      this.querySelector('[data-vk-apparatus-details]').hidden = !product;
      if (!product) return;
      this.querySelector('[data-vk-apparatus-selection]').textContent = product.title;
      this.apparatusVariant.replaceChildren();
      this.apparatusVariant.hidden = product.variants.length < 2;
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = this.dataset.apparatusVersion;
      this.apparatusVariant.append(placeholder);
      product.variants.forEach(variant => {
        const option = document.createElement('option');
        option.value = String(variant.id);
        option.textContent = `${variant.title} · ${this.money(this.discountedPrice(variant))}`;
        this.apparatusVariant.append(option);
      });
      this.apparatusVariant.value = this.apparatusVariantId ? String(this.apparatusVariantId) : '';
      const selected = this.selectedApparatusVariant();
      const single = this.querySelector('[data-vk-apparatus-single-version]');
      single.hidden = product.variants.length !== 1 || !selected || selected.title === 'Default Title';
      single.textContent = selected?.title || '';
      this.querySelector('[data-vk-apparatus-price]').hidden = !selected;
      if (selected) {
        this.querySelector('[data-vk-apparatus-original]').textContent = this.money(selected.price);
        this.querySelector('[data-vk-apparatus-discounted]').textContent = this.money(this.discountedPrice(selected));
      }
    }

    updatePanels() {
      this.panel.hidden = !this.toggle.checked;
      this.toggle.setAttribute('aria-expanded', String(this.toggle.checked));
      this.apparatusPanel.hidden = !this.apparatusToggle.checked;
      this.apparatusToggle.setAttribute('aria-expanded', String(this.apparatusToggle.checked));
    }

    async onToggle() {
      this.updatePanels();
      this.showError('');
      this.updateTotal();
      if (!this.hasOffer()) return;
      try { await this.refresh(); } catch { this.showError(this.dataset.loadError); }
    }

    showError(message) {
      this.error.textContent = message;
      this.error.hidden = !message;
    }

    async refresh() {
      if (this.refreshRequest) return this.refreshRequest;
      this.refreshRequest = this.loadCatalog();
      try { await this.refreshRequest; } finally { this.refreshRequest = null; }
    }

    async loadCatalog() {
      const url = new URL(this.dataset.url, location.origin);
      url.searchParams.set('section_id', 'vinkova-cover-catalog');
      url.searchParams.set('_vk_refresh', String(Date.now()));
      this.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(url, { cache: 'no-store', headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error(this.dataset.loadError);
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const coverData = page.querySelector('[data-vk-cover-catalog]');
        const apparatusData = page.querySelector('[data-vk-apparatus-catalog]');
        if (!coverData || !apparatusData) throw new Error(this.dataset.loadError);
        const covers = JSON.parse(coverData.textContent);
        const apparatus = JSON.parse(apparatusData.textContent);
        if (!Array.isArray(covers) || !Array.isArray(apparatus)) throw new Error(this.dataset.loadError);
        this.covers = covers;
        this.apparatus = apparatus;
        if (this.selectedId && !covers.some(item => item.id === this.selectedId)) this.select(null);
        if (this.apparatusId && !this.selectedApparatus()) {
          this.apparatusId = null;
          this.apparatusVariantId = null;
        } else if (this.apparatusVariantId && !this.selectedApparatusVariant()) this.apparatusVariantId = null;
        const coverScroll = this.grid.scrollTop;
        const apparatusScroll = this.apparatusGrid.scrollTop;
        this.render();
        this.grid.scrollTop = coverScroll;
        this.apparatusGrid.scrollTop = apparatusScroll;
      } finally { this.removeAttribute('aria-busy'); }
    }

    async prepare(formData) {
      if (!this.hasOffer()) return formData;
      if (this.toggle.checked && this.apparatusToggle.checked && this.dataset.combinationsReady !== 'true') {
        this.showError(this.dataset.combinationPending);
        throw new Error(this.dataset.combinationPending);
      }
      if (this.toggle.checked && !this.selectedId) {
        this.showError(this.dataset.choose);
        this.grid.querySelector('button')?.focus();
        throw new Error(this.dataset.choose);
      }
      if (this.apparatusToggle.checked && !this.selectedApparatusVariant()) {
        const message = this.apparatusId ? this.dataset.apparatusVersion : this.dataset.apparatusChoose;
        this.showError(message);
        if (this.apparatusId) this.apparatusVariant.focus();
        else this.apparatusGrid.querySelector('button')?.focus();
        throw new Error(message);
      }
      const coverId = this.toggle.checked ? this.selectedId : null;
      const apparatusId = this.apparatusToggle.checked ? this.apparatusVariantId : null;
      const quantity = Math.max(1, Number(formData.get('quantity') || 1));
      try { await this.refresh(); } catch { throw new Error(this.dataset.loadError); }
      const cover = coverId && this.covers.find(item => item.id === coverId);
      const apparatus = apparatusId && this.selectedApparatusVariant();
      if (coverId && (!this.toggle.checked || !cover || coverId !== this.selectedId)) throw new Error(this.dataset.unavailable);
      if (apparatusId && (!this.apparatusToggle.checked || !apparatus || apparatusId !== this.apparatusVariantId)) throw new Error(this.dataset.apparatusUnavailable);
      const cartResponse = await fetch(`${this.dataset.root.replace(/\/$/, '')}/cart.js`, { cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error(this.dataset.loadError);
      const cart = await cartResponse.json();
      const extras = [cover, apparatus].filter(Boolean);
      for (const item of extras) {
        const alreadyAdded = cart.items.filter(line => line.variant_id === item.id).reduce((sum, line) => sum + line.quantity, 0);
        if (item.stock < quantity + alreadyAdded) {
          const message = item === cover ? this.dataset.unavailable : this.dataset.apparatusUnavailable;
          this.showError(message);
          throw new Error(message);
        }
      }
      const combined = new FormData();
      for (const [name, value] of formData) {
        if (name === 'id' || name === 'quantity' || name === 'selling_plan') combined.append(`items[0][${name}]`, value);
        else if (/^properties\[.+\]$/.test(name)) combined.append(`items[0][properties][${name.slice(11, -1)}]`, value);
        else combined.append(name, value);
      }
      if (!formData.has('quantity')) combined.set('items[0][quantity]', String(quantity));
      extras.forEach((item, index) => {
        combined.set(`items[${index + 1}][id]`, String(item.id));
        combined.set(`items[${index + 1}][quantity]`, String(quantity));
      });
      return combined;
    }

    async onSubmit(event) {
      if (!this.hasOffer()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.submitting) return;
      this.submitting = true;
      const button = event.submitter || this.form.querySelector('[type="submit"]');
      button?.setAttribute('aria-busy', 'true');
      try {
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));
        const data = new FormData(this.form);
        data.set('sections', sections.join(','));
        data.set('sections_url', location.pathname);
        const response = await VinkovaCoverUpsell.send(this.form, data, this);
        const added = await response.json();
        if (!response.ok || added.status) throw new Error(added.description || this.dataset.unavailable);
        const cart = await (await fetch(`${this.dataset.root.replace(/\/$/, '')}/cart.js`)).json();
        cart.sections = added.sections;
        window.theme?.pubsub?.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: data.get('id'), cart });
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: added, vk: true } }));
        const cesta = document.querySelector('vk-cesta');
        const html = added.sections?.[cesta?.dataset.sectionId];
        if (cesta?.show(added, html)) return;
        const drawer = document.querySelector('cart-drawer');
        if (drawer?.show) drawer.show(button);
        else location.href = window.theme?.routes.cart_url || '/cart';
      } catch (error) { this.showError(error.message || this.dataset.loadError); }
      finally { this.submitting = false; button?.removeAttribute('aria-busy'); }
    }

    static async send(form, formData, component) {
      if (component) formData = await component.prepare(formData);
      return fetch(window.theme?.routes.cart_add_url || '/cart/add', { method: 'POST', body: formData, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
    }
  }
  window.VinkovaCoverUpsell = VinkovaCoverUpsell;
  customElements.define('vk-cover-upsell', VinkovaCoverUpsell);
})();
